<template>
    <form
        class="flex flex-col w-full h-full"
        @submit.prevent.stop="create"
    >
        <div class="py-2 container border-b inline-flex w-full">
            <i
                class="min-w-6 icon icon-close mr-4 my-2 cursor-pointer text-slate-400 hover:text-slate-600"
                @click="closeCreatePopup"
            ></i>
            <UserAvatar
                :name="isLoggedIn ? user.username : ''"
                :animated-avatar="isLoggedIn ? user.gamify_avatar_url : null"
                :picture="isLoggedIn ? userPicture : null"
                :show-details="false"
                :is-anonymous="post.postAnonymous && createPopupIsOpen"
                class="mr-2 h-10 w-10"
            ></UserAvatar>
            <span class="truncated leading-10 font-medium mr-auto">{{
                post.postAnonymous ? $t('Post anonymously') : $t('Post as {name}', { name: user ? user.username : '' })
            }}</span>
            <BtnCta
                data-testid="post-create-form-mobile_btn-send"
                type="submit"
                icon="send"
                class="ml-2"
                size="sm"
                :disabled="isPosting || isUploading"
            />
        </div>
        <textarea
            ref="text"
            v-model="post.text"
            :placeholder="$t('post:askQuestion')"
            class="bg-white w-full py-5 container resize-none outline-none border-0"
        ></textarea>
        <PostCreatePoll
            v-if="post.hasPoll"
            class="flex-none mb-18"
            :multi-vote="pollMultiVote"
            @update-poll-options="updatePollOptions"
            @update-multi-vote="updatePollMultiVote"
        ></PostCreatePoll>
        <PostPhotoUpload
            v-if="post.hasPhoto"
            :files="photo.files"
            class="flex-none p-4 mb-18 border-t w-full whitespace-nowrap"
            @upload-start="isUploading = true"
            @upload-end="isUploading = false"
        ></PostPhotoUpload>
        <div class="flex-none bg-white absolute left-0 bottom-0 w-full py-4 container inline-flex border-t">
            <Btn
                v-if="isAnonymityEnabled"
                data-testid="post-create-form-mobile_btn-anonymous"
                variant="tonal"
                :class="['btn-anonymous ml-auto mr-2', user?.is_premium ? 'text-slate-400' : 'text-purple-500']"
                :content-color="user?.is_premium ? 'slate-600' : 'purple-500'"
                active-color="blue-600"
                active-content-color="blue-600"
                icon="incognito"
                size="sm"
                :active="post.postAnonymous"
                color-on-touch
                @click.prevent.stop="toggle('postAnonymous')"
            />
            <Btn
                data-testid="post-create-form-mobile_btn-image"
                variant="tonal"
                class="mr-2 text-slate-400"
                content-color="slate-600"
                active-color="blue-600"
                active-content-color="blue-600"
                icon="camera"
                size="sm"
                :active="post.hasPhoto"
                color-on-touch
                @click.prevent.stop="toggle('hasPhoto')"
            />
            <Btn
                data-testid="post-create-form-mobile_btn-poll"
                variant="tonal"
                class="mr-0 text-slate-400"
                content-color="slate-600"
                active-color="blue-600"
                active-content-color="blue-600"
                icon="poll"
                size="sm"
                :active="post.hasPoll"
                color-on-touch
                @click.prevent.stop="toggle('hasPoll')"
            />
        </div>
    </form>
</template>

<script>
import { mapGetters } from 'vuex';
import { inject } from 'vue';
import { provideNewMarkingKey } from '@/components/keys';
import { BtnSize } from '@components/Btn';
import PostPhotoUpload from '@components/PostItem/PostPhotoUpload.vue';
import { featureIsEnabled } from '@/modules/features';
import PostCreateForm from './PostCreateForm.vue';

export default {
    name: 'PostCreateFormMobile',
    components: { PostPhotoUpload },
    extends: PostCreateForm,
    i18nOptions: { namespaces: ['common', 'post'] },
    setup() {
        const newMarking = inject(provideNewMarkingKey);
        return { newMarking };
    },
    data() {
        return {
            BtnSize,
        };
    },
    computed: {
        ...mapGetters('auth', ['user']),
        isAnonymityEnabled() {
            return featureIsEnabled('anonymityIdentity') && this.user?.is_premium_system_enabled;
        },
    },
    mounted() {
        this.$refs.text.focus();
    },
};
</script>

<style lang="scss" scoped>
textarea {
    height: calc(100% - 9rem);
}

.poll {
    textarea {
        height: 4.5rem;
    }
}

.truncated {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.photo {
    textarea {
        height: calc(100% - 16rem);
    }
}
</style>
